import { T } from '@tribeplatform/react-components/i18n'
import { useNavigate } from '@tribeplatform/react-components/Link'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  id: string
  name: string
  openOrganizationModal: () => void
  openCollectionModal: () => void
  openDeleteCollectionModal: () => void
}
export const CollectionItemButton = ({
  id,
  name,
  openOrganizationModal,
  openCollectionModal,
  openDeleteCollectionModal,
}: Props) => {
  const navigate = useNavigate()

  return (
    <>
      <div className="flex items-center">
        <div className="flex-1 truncate font-semibold">{name}</div>
        <div
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
          }}
        >
          <Dropdown placement="bottom-end">
            <Dropdown.ButtonMinimal as="div">
              <IconButton
                size="sm"
                variant="tertiaryNeutral"
                rounded
                icon={<SvgIcon name="dots-horizontal" />}
              />
            </Dropdown.ButtonMinimal>
            {id ? (
              <Dropdown.Items>
                <Dropdown.Item
                  leadingIcon={<SvgIcon name="package-plus" />}
                  onClick={() => {
                    navigate(
                      `/manage/customizer/create-space?collectionId=${id}`,
                    )
                  }}
                >
                  <T id="Generics.AddSpace" defaultMessage="Add {SPACE}" />
                </Dropdown.Item>
                <Dropdown.Item
                  leadingIcon={<SvgIcon name="list-unordered" />}
                  onClick={openOrganizationModal}
                >
                  <T id="Generics.Organize" defaultMessage="Organize" />
                </Dropdown.Item>
                <Dropdown.Item
                  leadingIcon={<SvgIcon name="edit" />}
                  onClick={openCollectionModal}
                >
                  <T
                    id="Blocks.CollectionHeader.EditCollection"
                    defaultMessage="Edit {COLLECTION}"
                  />
                </Dropdown.Item>
                <Dropdown.Item
                  leadingIcon={<SvgIcon name="trash" />}
                  onClick={openDeleteCollectionModal}
                >
                  <T defaultMessage="Remove" id="Generics.Remove" />
                </Dropdown.Item>
              </Dropdown.Items>
            ) : (
              <Dropdown.Items>
                <Dropdown.Item
                  leadingIcon={<SvgIcon name="package-plus" />}
                  onClick={() => {
                    navigate(`/manage/customizer/create-space`)
                  }}
                >
                  <T id="Generics.AddSpace" defaultMessage="Add {SPACE}" />
                </Dropdown.Item>
              </Dropdown.Items>
            )}
          </Dropdown>
        </div>
      </div>
    </>
  )
}
